import ListItem from "@material-ui/core/ListItem/ListItem";
import {convertISODateTimeToBRLocale} from "../common/Util";
import React from "react";
import {Typography} from "@material-ui/core";

export const renderDateTimeToListItem = function( t, dt, displaySeconds, ehDuracao) {
    displaySeconds = displaySeconds || false;
    ehDuracao = ehDuracao || false;
    if (new Date(dt).getFullYear() > 2016) {
        return (
            <ListItem style={{display:'flex', justifyContent:'space-between'}}>
                <Typography style={{fontSize: '0.8rem'}}>{t}</Typography>
                <Typography style={{fontSize: '1.1rem'}}>{convertISODateTimeToBRLocale(dt, displaySeconds)}</Typography>
            </ListItem>
        )
    }
}


export const renderMilisecondsToTimeDuration = function(ms) {
    if (!ms || ms === null || ms < 0 ) { return "" }
    const days = Math.floor(ms / (24*60*60*1000));
    const daysms=ms % (24*60*60*1000);
    const hours = Math.floor((daysms)/(60*60*1000));
    const hoursms=ms % (60*60*1000);
    const minutes = Math.floor((hoursms)/(60*1000));
    const minutesms=ms % (60*1000);
    const sec = Math.floor((minutesms)/(1000));
    return ((days>0)? days+"d " : '')  +((days>0 || hours>0)?hours.toString().padStart(2,'0')+':' : '') +minutes.toString().padStart(2,'0')+":"+sec.toString().padStart(2,'0')+'s';
}
